import * as React from 'react';
import {FunctionComponent} from 'react';
import {FullWorkout} from '../../../../Models/FullWorkout';
import {classNames} from '../../../Support/classNames';
import {format} from 'date-fns';
import {Link} from 'react-router-dom';

interface OwnProps {
    fullWorkout: FullWorkout;
    className?: string;
}

export const TrainingPlanHistory: FunctionComponent<OwnProps> = ({fullWorkout, className}) => {
    if (fullWorkout.training_plan === null) {
        return null;
    }
    return (
        <div className={classNames('card', className)}>
            <div className="card-title">
                <h5>History</h5>
            </div>
            <div className="card-body">
                <p>Compare previous executions of this training plan</p>
                <table className="table">
                    <tbody>
                        {fullWorkout.training_plan.workouts.map((workout, key) => {
                            return (
                                <tr key={workout.id}>
                                    <td className="d-flex flex-row gap-2">
                                        <Link to={`/workouts/show/${workout.id}`}>
                                            {format(workout.executed_at, 'dd-MM-yyyy')}
                                        </Link>
                                        {workout.id === fullWorkout.id && (
                                            <div className="badge rounded-pill bg-primary">this workout</div>
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
